import { render, staticRenderFns } from "./Culling.vue?vue&type=template&id=5b88c59a&"
import script from "./Culling.vue?vue&type=script&lang=js&"
export * from "./Culling.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports